import React, { ReactElement } from 'react';

import * as Styled from './Grid.styles';
import { ICellProps, IGridProps } from './Grid.types';

const Cell = ({ children, ...rest }: ICellProps): ReactElement => <Styled.Cell {...rest}>{children}</Styled.Cell>;

const Grid = ({ children, ...rest }: IGridProps): ReactElement => <Styled.Grid {...rest}>{children}</Styled.Grid>;

Grid.Cell = Cell;

export default Grid;
